export default __webpack_public_path__ + "static/media/germany.bc34c072.svg";